import { AppSingletonUtil } from 'src/app/Util/AppSingletonUtil';
import { UserInfoPanelController } from './UserInfoPanelController';
import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { SlideLeft, SlideRight } from 'src/app/Util/AnimationUtil';
import { BasePanelSlide } from 'src/app/View/BaseUI/BasePanelSlide';
import { HtmlStringConst } from 'src/app/Enum/HtmlStringConst';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import {patternForKana, patternForName, patternForPostCode} from '../../../../../../Util/StringUtil';
import {PrefectureConst} from '../../../../../../Enum/PrefectureConst';

@Component({
	selector: 'app-mypage-component',
	templateUrl: './UserInfoPanelComponent.html',
	styleUrls: ['./UserInfoPanelComponent.scss'],
	animations: [
		SlideLeft,
		SlideRight
	],
})
export class UserInfoPanelComponent extends BasePanelSlide {

	// 対となるコントローラー
	public combineCtrl: UserInfoPanelController;

	// ジェスチャー
	@ViewChild('gesturePage', { read: ElementRef, static: false }) gesturePage: ElementRef;

	// 元々保持していたユーザー情報
	private orgUserInfo: any;
	// 更新のためのユーザー情報
	public userInfo: UserInfoDataModel = new UserInfoDataModel();

	// 編集モードかどうかのフラグ
	public isEditMode = false;
	// 入力の表示モード
	public inputAppearance: MatFormFieldAppearance = 'standard';

	// カルテ情報の編集モードフラグ
	public isMedEditMode = false;
	// カルテ情報の表示モード
	public inputMedAppearance: MatFormFieldAppearance = 'standard';
	// ミドルネームフラグ
	public middleNameFlagChecked = false;

	public prefectureList = PrefectureConst.getList();
	/**
	 * constructor
	 */
	constructor(public dialogCtrl: MatDialog, public renderer: Renderer2) {

		// Angulerのコンポーネントなので、上位を呼ぶ必要がある
		super();

		// コントローラーの生成
		this.createController(UserInfoPanelController);

	}

	/**
	 * 開始処理
	 */
	public async start() {

		// スワイプでロケーションバックを非活性にする
		this.disablePhoneSwipeBack();

		// シングルトンで保持されているであろう、ユーザー情報を取得
		const ret = await this.execFuncWithErrorHandling(
			this,
			this.combineCtrl.getUserInfo.bind(this),
			{ view: this }
		);
		if (!ret) {
			return;
		}
		if (ret.medicalRecord.hasOwnProperty('wellnestClinic') === false) {
			ret.medicalRecord = {
				wellnestClinic: {
					medicalRecordNumber: '',
					type: '',
				},
				wellnestMentalClinic: {
					medicalRecordNumber: '',
					type: '',
				}
			};
		}
		Object.assign(this.userInfo, ret);

		// ミドルネーム登録済みの場合はミドルネームフラグにチェックを入れる
		if (this.userInfo.middlename) {
			this.middleNameFlagChecked = true;
		}

		// スライドイン表示は自分でやる
		await this.slideIn();

		// ジェスチャーを与える対象を設定する
		this.setGestureTargetElementRef(this.gesturePage);

	}

	////////////////////////////////
	// 画面イベント
	/**
	 * onClickEditUserData
	 * ユーザー情報の編集ボタン
	 */
	public async onClickEditUserData() {

		// オリジナルのユーザー情報を退避
		this.orgUserInfo = { ...this.userInfo };
		this.isEditMode = true;	// 編集モードをONにする
		this.inputAppearance = 'outline';

		if (this.orgUserInfo.medicalRecord.wellnestClinic.medicalRecordNumber === '') {
			this.isMedEditMode = true;
			this.inputMedAppearance = 'outline';
		}

	}

	/**
	 * 郵便番号から住所を自動入力
	 */
	public async onClickAutoInputAddress() {
		this.log('UserInfoPanelComponent::onClickAutoInputAddress()');
		const ret = await this.execFuncWithErrorHandling(
			this,
			this.combineCtrl.getAddress.bind(this),
			{ view: this, postCode: this.userInfo.postCode }
		);
		if (!ret) {
			return;
		}
		this.userInfo.prefecture = ret.prefecture;
		this.userInfo.city = ret.city;
	}

	/**
	 * onClickRegisterUserData
	 * ユーザー情報の登録ボタン
	 */
	public async onClickRegisterUserData() {

		this.log(this.userInfo);

		// 入力内容をチェックして、エラーメッセージがあれば、表示して終了
		const errMsg = this.combineCtrl.checkInputData(this.userInfo);
		if(errMsg.length > 0) {
			// エラーがあった場合は表示しておわり
			await this.showAlertDialog('エラー', errMsg.join(HtmlStringConst.BR));
			return;
		}

		if (this.userInfo.medicalRecord.wellnestClinic.medicalRecordNumber) {
			const inputMedicalRecordNumber = this.userInfo.medicalRecord.wellnestClinic.medicalRecordNumber;
			if (inputMedicalRecordNumber.length === 7) {
				this.userInfo.medicalRecord.wellnestClinic.medicalRecordNumber = inputMedicalRecordNumber.padStart(8 ,'0');
			}
		} else {
			this.isMedEditMode = false;
		}

		if (!this.middleNameFlagChecked) {
			this.userInfo.middlename = '';
		}

		// 編集したユーザー情報の登録
		const ret = await this.execFuncWithErrorHandling(
			this,
			this.combineCtrl.editUserInfo.bind(this),
			{
				view: this,
				data: this.userInfo,
				isMedEdit: this.isMedEditMode
			}
		);
		if (!ret) {
			return;
		}

		// オリジナルのユーザー情報を書き換え
		this.orgUserInfo = { ...this.userInfo };
		AppSingletonUtil.setUserInfo(this.orgUserInfo); // ユーザー情報の更新
		this.isEditMode = false; // 編集モードをOFF
		this.inputAppearance = 'standard';

		this.isMedEditMode = false; // 編集モードをOFF
		this.inputMedAppearance = 'standard';

	}

	/**
	 * onClickCancelEdit
	 * ユーザー情報の編集キャンセル
	 */
	public async onClickCancelEdit() {

		// 退避していたオリジナルのユーザー情報を戻す
		this.userInfo = { ...this.orgUserInfo };
		this.isEditMode = false; // 編集モードをOFF
		this.inputAppearance = 'standard';

		this.isMedEditMode = false; // 編集モードをOFF
		this.inputMedAppearance = 'standard';

	}


	protected readonly patternForName = patternForName;
	protected readonly patternForKana = patternForKana;
	protected readonly patternForPostCode = patternForPostCode;
}



// ユーザー情報の初期化モデル
class UserInfoDataModel {

	public lastname = '';
	public firstname = '';
	public lastnameKana = '';
	public firstnameKana = '';
	public middlename = '';
	public gender = '';
	public birthday = '';
	public telNumber = '';
	public deviceType = '';
	public postCode = '';
	public prefecture = '';
	public city = '';
	public address = '';
	public building = '';
	public toName = '';
	public email = '';
	public medicalRecord = {
		wellnestClinic: {
			medicalRecordNumber: '',
			type: '',
		},
		wellnestMentalClinic: {
			medicalRecordNumber: '',
			type: '',
		}
	};

}
